export interface IPesquisaVendedores {
    id: number;
    nome: string;
}   

export const defValueVendedor: IPesquisaVendedores = {
    id: 0,
    nome: ""
}